const labelsAppearance = {
  HORIZONTAL: "horizontal",
  VERTICAL: "verical",
  ANGLED: "angled"
};

export default labelsAppearance;
